<script lang="ts">
	import Message from '$lib/components/dialogs/Message.svelte'
	import { messages } from '$lib/messages'

	const handleCloseMessage = (id: string) => {
		messages.remove(id)
	}
</script>

<div class="fixed inset-x-2 top-2 z-40">
	{#each $messages as message (message.id)}
		<Message {message} on:close={() => handleCloseMessage(message.id)} />
	{/each}
</div>
